const AccessTypes = {
  VIEW: "VIEW",
  EDIT: "EDIT"
};

export default AccessTypes;
